<app-page-wrapper>
    <app-loading-spinner *ngIf="loading.assignment;else main_content"></app-loading-spinner>
    
    <ng-template #main_content>
        <app-loading-spinner *ngIf="loading.class"></app-loading-spinner>
        <div class="my-4" *ngIf="!loading.class">
            <a (click)="tryGoBack()" class="breadcrumb-link pointer">
              <i class="far fa-angle-left"></i>
              {{ class.Description }}
            </a>
        </div>
        <div class="assignment-header-background justify-content-between d-flex">
            <div class="d-flex">
                <h2 class="assignment-header-title">Assignment Details: </h2>
                <i class="{{getIconForState(assignmentState)}} state-icon"></i>
                <div class="assignment-header-info">{{ assignment.ActivitySequence.Name }}</div>
            </div>
            <div class="assignment-header-info">
                {{ longDateFormat(assignment.StartDate) }} - {{ longDateFormat(assignment.EndDate) }}
            </div>
            <div class="assignment-header-info">
                Assigned to: {{getAssignedStudentsText()}}
                
            </div>
            <div>
                <span *ngIf="assignmentState === 'upcoming' && !isPostTestAssignment()" (click)="editAssignment.openForEdit(assignment)">
                    <i class="far fa-pencil-alt pointer"></i>
                </span>
                <app-add-or-edit-assignment-modal [openModalButtonVisible]="false"
                    #editAssignment [organizationId]="organizationId" [students]="students">
                </app-add-or-edit-assignment-modal>
            </div>
        </div>
        <table class="table">
            <thead>
                <th></th>
                <th>Activities</th>
                <th></th>
                <th></th>
                <th>Est. Time</th>
            </thead>
            <tbody cdkDropList (cdkDropListDropped)="activityMoved($event)" 
                    [cdkDropListDisabled]="editableAssignedActivities.length < 2">
                <tr *ngFor="let uneditableActivity of uneditableAssignedActivities">
                    <td></td>
                    <td>
                        <div>
                            <app-loading-spinner [noMargin]="true" *ngIf="loading.categories"></app-loading-spinner>
                            <span *ngIf="!loading.categories">{{ getCategoryTextForActivity(uneditableActivity) }}</span>
                        </div>
                    </td>
                    <td>
                        <div>
                            <app-loading-spinner [noMargin]="true" *ngIf="!activityLists[uneditableActivity.CategoryID]"></app-loading-spinner>
                            <span *ngIf="activityLists[uneditableActivity.CategoryID]">{{ getActivityTextForActivity(uneditableActivity) }}</span>
                        </div>
                    </td>
                    <td>
                        <div>
                            <app-loading-spinner [noMargin]="true" *ngIf="!unitLists[uneditableActivity.ActivityID] && !kadyChainPrompt(uneditableActivity)"></app-loading-spinner>
                            <span *ngIf="unitLists[uneditableActivity.ActivityID] && !kadyChainPrompt(uneditableActivity)">{{ getUnitTextForActivity(uneditableActivity) }}</span>
                            <span *ngIf="kadyChainPrompt(uneditableActivity)"> {{ uneditableActivity.ExtraData }} </span>
                        </div>
                    </td>
                    <td>
                        <span *ngIf="uneditableActivity.MinTime || uneditableActivity.MaxTime">
                            {{uneditableActivity.MinTime || 0}}-{{uneditableActivity.MaxTime || 0}} min
                        </span>
                    </td>
                </tr>
                <tr *ngFor="let assignedActivity of editableAssignedActivities; index as aaIndex" cdkDrag cdkDragLockAxis="y">
                    <td cdkDragHandle>
                        <i class="fas fa-ellipsis-v pointer" *ngIf="editableAssignedActivities.length > 1"></i>
                    </td>
                    <td>
                        <select class="form-control unloaded" disabled [ngClass]="{invalid:isCategoryInvalid(aaIndex)}"
                                *ngIf="!loading.categories && (!activityCategories || activityCategories.length == 0)">
                            <option value="" disabled selected hidden>Select category</option>
                        </select>
                        <app-loading-spinner [noMargin]="true" *ngIf="loading.categories"></app-loading-spinner>
                        <select class="form-control" *ngIf="!loading.categories && activityCategories && activityCategories.length > 0"
                                [(ngModel)]="assignedActivity.CategoryID" (change)="categoryChanged(aaIndex)" [ngClass]="{invalid:isCategoryInvalid(aaIndex)}">
                            <option [ngValue]="undefined" hidden>Select category</option>
                            <option *ngFor="let category of activityCategories" [ngValue]="category.ID">
                                {{ category.Description }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <select class="form-control unloaded" disabled [ngClass]="{invalid:isActivityInvalid(aaIndex)}"
                                *ngIf="!assignedActivity.CategoryID">
                            <option value="" disabled selected hidden>Select activity</option>
                        </select>
                        <app-loading-spinner [noMargin]="true" *ngIf="assignedActivity.CategoryID && !activityLists[assignedActivity.CategoryID]"></app-loading-spinner>
                        <select class="form-control" [(ngModel)]="assignedActivity.ActivityID" (change)="activityChanged(aaIndex)"
                                *ngIf="assignedActivity.CategoryID && activityLists[assignedActivity.CategoryID]" 
                                [ngClass]="{invalid:isActivityInvalid(aaIndex)}" (focus)="setActivitySummary(aaIndex)">
                            <option [ngValue]="undefined" hidden>Select activity</option>
                            <option *ngFor="let activity of activityLists[assignedActivity.CategoryID]" [ngValue]="activity.ActivityID">
                                <P *ngIf="activity.Level<8">L{{activity.Level}} - {{activity.Title}}{{activity.Description ? " (" + activity.Description + ")" : ""}}</P>
                                <P *ngIf="activity.Level==8">OB - {{activity.Title}}{{activity.Description ? " (" + activity.Description + ")" : ""}}</P>
                                <P *ngIf="activity.Level==9">DC - {{activity.Title}}{{activity.Description ? " (" + activity.Description + ")" : ""}}</P>
                                <P *ngIf="activity.Level==10">KC - {{activity.Title}}{{activity.Description ? " (" + activity.Description + ")" : ""}}</P>
                                <P *ngIf="activity.Level>10 && activity.Level<15">PW - {{activity.Title}}{{activity.Description ? " (" + activity.Description + ")" : ""}}</P>
                            </option>
                        </select>
                    </td>
                    <td>
                        <select class="form-control unloaded" disabled [ngClass]="{invalid:isUnitInvalid(aaIndex)}"
                                *ngIf="!assignedActivity.ActivityID">
                            <option value="" disabled selected hidden>Select unit</option>
                        </select>
                        <app-loading-spinner [noMargin]="true" *ngIf="assignedActivity.ActivityID && !unitLists[assignedActivity.ActivityID]"></app-loading-spinner>
                        <select class="form-control" [(ngModel)]="assignedActivity.UnitNumber" (change)="unitChanged(aaIndex)"
                                    *ngIf="assignedActivity.ActivityID && unitLists[assignedActivity.ActivityID] && !kadyChainPrompt(assignedActivity)" 
                                    [ngClass]="{invalid:isUnitInvalid(aaIndex)}">
                                <option [ngValue]="undefined" hidden>Select unit</option>
                                <option *ngFor="let unit of unitLists[assignedActivity.ActivityID]" [ngValue]="unit.Number">
                                    {{unit.Number}}. {{unit.Description}}
                                </option>
                        </select>
                        <input [(ngModel)]="assignedActivity.ExtraData" *ngIf="kadyChainPrompt(assignedActivity)" 
                            maxlength="20" type="text" placeholder="Example: colors">
                    </td>
                    <td>
                        <span *ngIf="assignedActivity.MinTime || assignedActivity.MaxTime">
                            {{assignedActivity.MinTime || 0}}-{{assignedActivity.MaxTime || 0}} min
                        </span>
                    </td>
                    <td *ngIf="assignedActivity.CategoryID">
                        <span (click)="clearActivityRow(aaIndex)"><i class="far fa-trash-alt pointer"></i></span>
                    </td>
                    <div *cdkDragPreview>
                        <td><i class="fas fa-ellipsis-v"></i></td>
                        <td><select class="form-control"><option>{{getCategoryTextForActivity(assignedActivity)}}</option></select></td>
                        <td><select class="form-control"><option>{{getActivityTextForActivity(assignedActivity)}}</option></select></td>
                        <td><select class="form-control"><option>{{getUnitTextForActivity(assignedActivity)}}</option></select></td>
                        <td *ngIf="assignedActivity.MinTime || assignedActivity.MaxTime">
                            {{assignedActivity.MinTime || 0}}-{{assignedActivity.MaxTime || 0}} min
                        </td>
                    </div>
                </tr>
                <tr *ngIf="activityLimitReached()"
                    ngbTooltip="Activity limit reached">
                    <td>
                    </td>
                    <td>
                        <select class="form-control unloaded" disabled>
                            <option value="" disabled selected hidden>Select category</option>
                        </select>
                    </td>
                    <td>
                        <select class="form-control unloaded" disabled>
                            <option value="" disabled selected hidden>Select activity</option>
                        </select>
                    </td>
                    <td>
                        <select class="form-control unloaded" disabled>
                            <option value="" disabled selected hidden>Select unit</option>
                        </select>
                    </td>
                    <td></td>
                </tr>
            </tbody>
        </table>
        <div class="d-flex justify-content-center" *ngIf="isAnyError()">
            <span class="error-message">
                You have not completed your selection(s).
            </span>
        </div>
        <div class="grid">
            <div class="row">
                <div class="col-6">
                    <div class="activity-summary d-flex" *ngIf="activitySummary">
                        <img class="thumbnail" src="../assets/thumbnails/{{activitySummary.ImageName}}.png" *ngIf="activitySummary.ImageName">
                        <span>
                            {{ activitySummary.Summary }}
                        </span>
                    </div>
                </div>
                <div class="col-6 d-flex buttons" *ngIf="!saving">
                    <button class="btn btn-outline-secondary mr-2" (click)="tryGoBack()">
                        Cancel
                    </button>
                    <button class="btn btn-primary" (click)="save()" *ngIf="assignmentState !== 'completed'">
                        Save Assignment
                    </button>
                </div>
                <div class="col-6" *ngIf="saving">
                    <app-loading-spinner text="Saving..."></app-loading-spinner>
                </div>
            </div>
        </div>
    </ng-template>
</app-page-wrapper>